import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ContentService } from '../../services/content.service';
import { MenuNavListingComponent } from '../menu-nav-listing/menu-nav-listing.component';

@Component({
    selector: 'app-add-traveler',
    templateUrl: './add-traveler.component.html',
    styleUrls: ['./add-traveler.component.scss'],
    imports: [MenuNavListingComponent]
})
export class AddTravelerComponent implements OnInit, OnDestroy {
private destroy$ = new Subject<void>();
content:any;
  constructor(private contentService:ContentService){

}
ngOnInit(){
  this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
    this.content = res;
  });
}
ngOnDestroy(){
  this.destroy$.next();
  this.destroy$.complete();
}
}
